import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideUiUtilities, tokenInterceptor } from '@anddone/ui-utilities';
import { environment } from '../environments/environment';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';


/**
 * Factory function that creates TranslateHttpLoader
 *
 * This loader is responsible for loading translation JSON files
 * using Angular HttpClient.
 *
 * Actual file path configuration (prefix/suffix) is provided
 * through TRANSLATE_HTTP_LOADER_CONFIG provider.
 */
export function httpLoaderFactory() {
  return new TranslateHttpLoader();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()), // Configures Angular Router with defined routes and hash-based navigation.

    provideHttpClient(withInterceptors([tokenInterceptor])),

    provideAnimations(), // Registers Angular animations module globally, required for ngx-toastr animations.
    provideToastr(),
    
    provideTranslateService({ // Registers ngx-translate translation service globally.
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory
      }
    }),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/i18n/',
        suffix: '.json'
      }
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.captchaKey,
    },

    provideUiUtilities({ // Registers Anddone UI Utilities globally with specified configuration.
      baseUrl: environment.baseUrl,
      serverPublicKey: ''
    })
  ]
};